import React from "react";
import { createRoot } from 'react-dom/client';

import App from './App.jsx';


(function ($, Drupal, drupalSettings) {
  'use strict';

  Drupal.behaviors.myCustomBehavior = {
    attach: function (context, settings) {
      $(once('myCustomBehavior', '#js-form-wrapper', context)).each(function () {
        const container = document.getElementById('js-form-wrapper');
        if(container){
          const root = createRoot(container);
          root.render(<App data={drupalSettings.ifapme_variations_cart} />);
        }else {
          console.error("No container - ", container)
        }
      });
    }
  };

})(jQuery, Drupal, drupalSettings);
